import React from 'react';
import {Input, Form, DatePicker, Button, Row, Col, Icon, Select} from 'antd';
import {RemoveEmptyEle,removePropertyOfNull} from '../../../utils';

import moment from "moment";

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const Render =({form,onFinish})=>{

	const formLargeItemLayout = {
		labelCol: {
			span: 4,
		},
		wrapperCol: {
			span: 18,
		},
	}

	const  handleSubmit =(e)=>{
	
		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				//清空一下空数据
				onFinish(removePropertyOfNull(values));
			}
		});
	}
	return (
		<Form  {...formLargeItemLayout}  >

			<Row gutter={24} >

				<Col span={5} >

					<Form.Item

						label='法人'
					>
						{form.getFieldDecorator('user_name', {
						})(
						<Input placeholder="法人姓名" />
						)}
					</Form.Item>

				</Col>
				<Col span={8} >
					<Form.Item

						label='授权时间'
					>
						{form.getFieldDecorator('auth_time', {
						})(
							<RangePicker showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('00:00:00', 'HH:mm:ss')] }} />
						)}

					</Form.Item>
				</Col>
				<Col span={9} >
					<Form.Item

						label='是否关联公司'
					>
						{form.getFieldDecorator('state',  {
							initialValue: '0',
						})(
							<Select  placeholder="是否关联公司"  >
								<Select.Option key='1' value={''}>全部</Select.Option>
								<Select.Option key='2' value={'0'} >否</Select.Option>
								<Select.Option key='3' value={'1'}>是</Select.Option>
							</Select>
						)}

					</Form.Item>
				</Col>
				<Col span={2}  >
					<Button type="primary" onClick ={handleSubmit}>   <Icon type="search" /> 查询</Button>
				</Col>
			</Row>

      </Form>

	)

}



const SearchRender = Form.create()(Render);


export default SearchRender;
